/*
   Default top-level page route names (excludes entity pages)
*/
export enum PageRoutes {
    /**
     * Server-side authentication route
     */
    ROOT = '/',
    AUTHENTICATE = '/authenticate',
    SIGN_UP = '/signup',
    LOG_IN = '/login',
    RESET_CREDENTIALS = '/reset',
    SEARCH_RESULTS = '/search/:type?',
    SEARCH = '/search',
    BROWSE = '/browse',
    BROWSE_RESULTS = '/browse/:type',
    BROWSE_DATAPRODUCT = '/browse/dataproduct',
    DATASETS = '/datasets',
    ASSETS = '/assets',
    ANALYTICS = '/analytics',
    POLICIES = '/policies',
    SETTINGS_POLICIES = '/settings/policies',
    PERMISSIONS = '/permissions',
    IDENTITIES = '/identities',
    INGESTION = '/ingestion',
    SETTINGS = '/settings',
    TOKENS = '/tokens',
    OWNERSHIP = '/ownership',
    DOMAINS = '/domains',
    DOMAIN = '/domain',
    GLOSSARY = '/glossary',
    GLOSSARY_NODE = '/glossaryNode*',
    SETTINGS_VIEWS = '/settings/views',
    EMBED = '/embed',
    EMBED_LOOKUP = '/embed/lookup/:url',
    SETTINGS_POSTS = '/settings/posts',
    BROWSE_DATASET = '/browse/dataset',
    DATASET_DETAILS = '/dataset*',
    DATA_PRODUCT_DETAILS = '/dataProduct*',
    BROWSE_DATA_PRODUCT = '/browse/dataProduct',
    BROWSE_CHART = '/browse/chart',
    CHART_DETAILS = '/chart*',
    BROWSE_DASHBOARD = '/browse/dashboard',
    DASHBOARD_DETAILS = '/dashboard*',
    BROWSE_PIPELINES = '/browse/pipelines',
    PIPELINE_DETAILS = '/pipelines*',
    BROWSE_FEATURE_TABLES = '/browse/featureTables',
    FEATURE_TABLE_DETAILS = '/featureTables*',
    BROWSE_ML_MODELS = '/browse/mlModels',
    ML_MODEL_DETAILS = '/mlModels*',
    BROWSE_ML_MODEL_GROUP = '/browse/mlModelGroup',
    ML_MODEL_GROUP_DETAILS = '/mlModelGroup*',
    GLOSSARY_TERM_DETAILS = '/glossaryTerm*',
    GROUP = '/group*',
    USER = '/user*',
    CONTAINER = '/container*',
    TAG = '/tag*',
}

/**
 * Name of the auth cookie checked on client side (contains the currently authenticated user urn).
 */
export const CLIENT_AUTH_COOKIE = 'actor';

/**
 * Name of the unique browser id cookie generated on client side
 */
export const BROWSER_ID_COOKIE = 'bid';

/**
 * Name of the xsrf cookie checked on client side.
 */
export const XSRF_TOKEN = 'EDC-XSRF-TOKEN';
